export const backend = 'http://thedezlab.com:777/';
export const frontend = 'https://localhost:3000/';
export const database = 'localhost';
